import { useSelector } from "react-redux"
import { ContainerFull } from "../../components/ContainerFull"
import { Wrapper } from "../../components/Wrapper"
import { PaymentHistoryById } from "./Shared/PaymentHistoryById"
import { PaymentUploadCard } from "./Shared/PaymentUploadCard"

export const PaymentStudentPage = () => {
	const { paymentsByUser, loading: allPaymentUserLoading } = useSelector((state) => state.payment);

	const paymentPendingCheck = paymentsByUser.some(payment => payment.status !== 'validado');
	return (
		<ContainerFull>
			<Wrapper>
				<div className="grid grid-cols-1 md:grid-cols-5 gap-4">
					<div className="col-span-5 md:col-span-2 order-3 md:order-1 ">
						<PaymentHistoryById action={true} />
					</div>
					<div className="col-span-5 md:hidden order-2 border-b-[1px] border-gray-100 h-10">
					</div>
					<div className="col-span-5 md:col-span-3 order-1 md:orden-2">
						{
							(!allPaymentUserLoading && !paymentPendingCheck) && (
								<PaymentUploadCard />
							)
						}
					</div>
				</div>
			</Wrapper>
		</ContainerFull>
	)
}
